import * as React from "react";
import {connect} from "react-redux";
import Lead from "../../../model/lead/Lead";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import IndividualContact from "../../../model/contact/IndividualContact";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DropDownList, {DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import SearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import {Dispatch} from "redux";
import {addCallEvent, editLead, sendEmailToLeadContact, sendSmsToLeadContact} from "../../../store/action/lead/lead";
import Toast from "../../helper/Toast";
import TextUtils from "../../../utils/TextUtils";
import EditIndividualContactModal from "../../contacts/modal/EditIndividualContactModal";
import CreateContactModal from "../../contacts/modal/CreateContactModal";
import MessageModal from "./MessageModal";
import TwilioModal from "./TwilioModal";
import AddEventModal from "./AddEventModal";
import EmailMessageModal from "./EmailMessageModal";
import * as _ from "underscore";
import {fetchIndividualContacts} from "../../../store/action/contacts/contacts";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {getIndividualContact} from "../../../store/view/contact";

interface ComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface ReduxProps {
	/**
	 * Organisation individual contacts.
	 */
	individualContacts: IndividualContact[],
	/**
	 * Indicates if all contacts are fetched
	 */
	allContactsFetched: boolean
	/**
	 * Contact
	 */
	contact: Option<IndividualContact>;
}

interface DispatchProps {
	/**
	 * Edit lead action.
	 * @param {Lead} lead
	 */
	editLead: (lead: Lead) => void;
	/**
	 * Send sms to lead contact action.
	 * @param {Lead} lead
	 */
	sendSmsToLeadContact: (leadId: string, message: string) => void;
	/**
	 * Send e-mail to lead contact action.
	 * @param {string} leadId
	 * @param {string} subject
	 * @param {string} message
	 */
	sendEmailToLeadContact: (leadId: string, subject: string, message: string) => void;
	/**
	 * Add phone call event
	 * @param {string} leadId
	 * @param {string} eventMessage
	 */
	addCallEvent: (leadId: string, eventMessage: string) => void;
	/**
	 * Fetch all individual contacts
	 */
	fetchContacts: () => void;
}

interface IState {
	/**
	 * Menu dropdown visibility.
	 */
	menuDropDownVisible: boolean
	/**
	 * Search dropdown visibility.
	 */
	searchBoxVisible: boolean
	/**
	 * New contact modal form visibility.
	 */
	newContactVisible: boolean
	/**
	 * Edit contact modal form visibility.
	 */
	editContactVisible: boolean
	/**
	 * Send sms to contact modal visibility.
	 */
	sendSmsModalVisible: boolean;
	/**
	 * Send e-mail to contact modal visibility.
	 */
	sendEmailModalVisible: boolean;
	/**
	 * Twilio call to contact modal visibility.
	 */
	twilioModal: boolean;
	/**
	 * Add event modal visibility.
	 */
	addEventModal: boolean;
}

type Props = ComponentProps & ReduxProps & DispatchProps

class Contact extends React.PureComponent<Props, IState> {

	selectedContactMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Create new"},
		{id: "l3", label: "Edit"},
		{id: "l4", label: "Send SMS", disabled: !this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)},
		{id: "l5", label: "Copy"},
		{
			id: "l6",
			label: "Call",
			disabled: this.props.contact.map(c =>
				c.data.communication.phoneNumbers.getOrElse([]).length == 0
			).getOrElse(true)
		},
		{id: "l7", label: "Add phone call event"}
	];

	emptyContactMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Create new"}
	];

	constructor(props: Props) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			searchBoxVisible: false,
			newContactVisible: false,
			editContactVisible: false,
			sendSmsModalVisible: false,
			sendEmailModalVisible: false,
			twilioModal: false,
			addEventModal: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onContactSelect = this.onContactSelect.bind(this);
		this.onEditSuccess = this.onEditSuccess.bind(this);
		this.onSmsSend = this.onSmsSend.bind(this);
		this.onEmailSend = this.onEmailSend.bind(this);
	}

	componentDidUpdate() {
		const contactWithoutPhones = this.props.contact.map(c =>
			c.data.communication.phoneNumbers.getOrElse([]).length == 0
		).getOrElse(true);

		const contactWithoutEmails = this.props.contact.map(c =>
			c.data.communication.emails.getOrElse([]).length == 0
		).getOrElse(true);

		this.selectedContactMenu = [
			{id: "l1", label: "Change"},
			{id: "l2", label: "Create new"},
			{id: "l3", label: "Edit"},
			{id: "l4", label: "Send SMS", disabled: !this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)},
			{id: "l5", label: "Send e-mail", disabled: contactWithoutEmails},
			{id: "l6", label: "Copy"},
			{id: "l7", label: "Call", disabled: contactWithoutPhones},
			{id: "l8", label: "Add phone call event"}
		];
	}

	render() {
		const menuItems = this.props.lead.isDefined ? this.selectedContactMenu : this.emptyContactMenu;
		return (
			<InfoModule icon={Icon.Phone} title={"CUSTOMER"} actionIcon={Icon.Overflow} onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => {this.setState({menuDropDownVisible: false})}}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  itemDisabled={(link: DropDownItem) => link.disabled}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.searchBoxVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({searchBoxVisible: false})}>
					<SearchDropDown items={this.props.individualContacts}
									onChange={this.onContactSelect}
									itemToLabel={(contact: IndividualContact) => contact.data.displayName()}
									itemToId={(contact: IndividualContact) => contact.id}
									searchInputIcon={Icon.User}
									isLoading={!this.props.allContactsFetched}/>
				</DropDownWrapper>
				}
				{
					this.props.contact.map(c => {
						return (
							<span className="t-body" style={{whiteSpace: "pre"}}>{c.data.fullDetails()}</span>
						)
					}).getOrElse(<span className="t-body">No customer selected</span>)
				}
				{this.state.newContactVisible &&
				<CreateContactModal onSuccessIndividual={this.onContactSelect}
									onClose={() => this.setState({newContactVisible: false})}/>
				}
				{this.state.editContactVisible && this.props.contact.isDefined &&
				<EditIndividualContactModal onSuccess={this.onEditSuccess}
											onClose={() => this.setState({editContactVisible: false})}
											contact={this.props.contact.get}/>
				}
				{this.state.sendSmsModalVisible &&
				<MessageModal
					onMessageSend={(value) => this.setState({sendSmsModalVisible: false}, () => {this.onSmsSend(value)})}
					onClose={() => this.setState({sendSmsModalVisible: false})}
					title={`Send SMS to: ${this.props.contact.get.data.displayName()} (${this.props.contact.get.displayMobileNumbers()})`}/>}
				{this.state.sendEmailModalVisible &&
				<EmailMessageModal onMessageSend={(subject, message) => this.setState({sendEmailModalVisible: false},
					() => {this.onEmailSend(subject, message)})}
								   onClose={() => this.setState({sendEmailModalVisible: false})}
								   title={`Send e-mail to: ${this.props.contact.get.data.displayName()} (${this.props.contact.get.displayEmailAddresses()})`}/>}
				{this.state.twilioModal &&
				<TwilioModal onClose={() => this.setState({twilioModal: false})} contact={this.props.contact.get}/>
				}
				{this.state.addEventModal &&
				<AddEventModal onAdd={(em) => this.setState({addEventModal: false}, () => {this.onAddEvent(em)})}
							   onClose={() => this.setState({addEventModal: false})}/>}
			</InfoModule>
		);
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false, searchBoxVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({searchBoxVisible: true, menuDropDownVisible: false});
				if (!this.props.allContactsFetched) {
					this.props.fetchContacts();
				}
				break;
			case "l2":
				this.setState({newContactVisible: true, menuDropDownVisible: false, searchBoxVisible: false});
				break;
			case "l3":
				this.setState({editContactVisible: true, menuDropDownVisible: false});
				break;
			case "l4":
				this.setState({sendSmsModalVisible: true, menuDropDownVisible: false});
				break;
			case "l5":
				this.setState({sendEmailModalVisible: true, menuDropDownVisible: false});
				break;
			case "l6":
				this.props.contact.map(c => TextUtils.copyToClipboard(c.data.fullDetails()));
				break;
			case "l7":
				this.setState({twilioModal: true, menuDropDownVisible: false});
				break;
			case "l8":
				this.setState({addEventModal: true, menuDropDownVisible: false});
				break;
		}
	}

	onContactSelect(contact: IndividualContact) {
		this.setState({searchBoxVisible: false, menuDropDownVisible: false, newContactVisible: false});
		this.props.lead.map(l => {
			if (l.data.principalContactId === contact.id)
				return;
			const updatedLead = l.copy({data: l.data.copy({principalContactId: contact.id})});
			this.props.editLead(updatedLead);
		});
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible, searchBoxVisible: false})
	}

	onEditSuccess() {
		this.setState({editContactVisible: false}, () => Toast.success("Lead customer updated", "Lead details update"))
	}

	onSmsSend(message: string) {
		this.props.lead.map(l => this.props.sendSmsToLeadContact(l.id, message));
	}

	onEmailSend(subject: string, message: string) {
		this.props.lead.map(l => this.props.sendEmailToLeadContact(l.id, subject, message));
	}

	onAddEvent(eventMessage: string) {
		this.props.lead.map(l => this.props.addCallEvent(l.id, eventMessage))
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		individualContacts: _.values(state.contact.individualContactMap),
		allContactsFetched: state.contact.allContactsFetched,
		contact: props.lead.flatMap(l => getIndividualContact(l.data.principalContactId, state))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead) => dispatch(
			editLead(
				lead,
				() => Toast.success("Lead customer updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		),
		sendSmsToLeadContact: (leadId: string, message: string) => dispatch(
			sendSmsToLeadContact(
				leadId,
				message,
				() => Toast.success("SMS has been send.", "Send SMS to customer"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Send SMS to customer")
			)
		),
		sendEmailToLeadContact: (leadId: string, subject: string, message: string) => dispatch(
			sendEmailToLeadContact(
				leadId,
				subject,
				message,
				() => Toast.success("E-mail has been send.", "Send e-mail to customer"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Send e-mail to customer")
			)
		),
		addCallEvent: (leadId: string, message: string) => dispatch(
			addCallEvent(
				leadId,
				message,
				() => Toast.success("Phone event has been added.", "Add phone event"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Add phone event")
			)
		),
		fetchContacts: () => dispatch(fetchIndividualContacts(() => {},
			(err) => {notifyBugsnagAndShowToast(err, 'Fetch contacts')}))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact)